import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "save-popup" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "You have unsaved changes.", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Save ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_button = _resolveComponent("loading-button")!
  const _component_save_spacer = _resolveComponent("save-spacer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, {
      name: "slide",
      appear: ""
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_loading_button, {
            "button-type": "button--inverted",
            class: "save-popup__button",
            loading: _ctx.loading
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["loading"])
        ], 512), [
          [_vShow, _ctx.show]
        ])
      ]),
      _: 1
    }),
    (_ctx.showSpacer)
      ? (_openBlock(), _createBlock(_component_save_spacer, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}